import React, { Component } from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { Input } from "@vds/inputs";
import { TextLink } from "@vds/buttons";
import { TitleLockup } from "@vds/type-lockups";
import { Body } from "@vds/typography";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { validateSecurePin, sendSecurePinToDevice, clearErrors,  } from "../actions";
import {resendPassword,downloadResendPassword} from "../actions/resendPassword"
import { setA11yContent } from "../../NavigationHelper/actions";
import { media ,isMobile } from "utils/style";
import { replaceHashValues } from "utils/replaceHashValues";
import { checkNestedObject } from "utils/checkNestedObject";
import { encryptData,decryptData } from "utils/decryptData";

import { checkAMLob } from "utils/checkAMLob";

import CommonContainer from "common-components/Container";
import CommonHeader from "common-components/Header";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import Button from "common-components/Buttons";
import Warning from "../../../../../assets/svgs/Warning.svg";

class MultifactorAuthentication extends Component {
  state = {
    showSuccessMessage: false,
    errorRequestingPin: false,
    pinLength: 0
  };
  InputRef= React.createRef();

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Multifactor Authentication", this.props.pageContent.sc_pagetitle);
    }
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  resendPassword = () => {
    this.props.resendPassword(this.props.uniqueTxnId).then(() => {
      const { state } = this.props.location;

      if (!this.props.resendPWError) {
        this.props.history.replace({
          pathname: state.nextRoute,
          state: { ...state }
        });
      }
    });
  };

  downloadResendPassword = () => {
    const { state } = this.props.location;
    var uniqueTxnId = state.uniqueTxnId ? state.uniqueTxnId : this.props.uniqueTxnId ? this.props.uniqueTxnId : ""

    this.props.downloadResendPassword(uniqueTxnId).then(() => {

      if (!this.props.resendPWError) {
        this.props.history.replace({
          pathname: state.nextRoute,
          state: { ...state }
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    this.setState({ showSuccessMessage: false, errorRequestingPin: false });
    if (this.props.location && this.props.location.state) {
      const inputVal = this.InputRef.current.value; //document.getElementById("multifactor_authentication")

      if (this.state.pinLength !== 10) {
        this.props.validateSecurePin(inputVal).then(() => {
          this.resetInputValue();
          this.setState({ pinLength: 0 });
          if (!this.props.error && (checkAMLob() === "agent" || encryptData(inputVal) === this.props.byPassEmail)) {          //CXTDT-665511 developer Arvind
            this.setState({ pinLength: 10 });

            const { state } = this.props.location;
            if (state.resendPWFlow) {
              if (state.requesPassword) {
                this.downloadResendPassword();
              } else {
                this.resendPassword();
              }

            } else {
              if (state.nextRoute) {
                this.props.history.replace({
                  pathname: state.nextRoute,
                  state: { ...state }
                });
              }
            }
           }
        });
      } else {
        this.resendPassword();
      }
    }
  };

  resendSecurePin = () => {
    
    this.resetInputValue();
    this.setState({ errorRequestingPin: false, showSuccessMessage: false, pinLength: 0 });

    this.props.sendSecurePinToDevice().then(() => {
      if (!this.props.error) {
        this.setState({ showSuccessMessage: true });
      } else {
        this.setState({ errorRequestingPin: true });
      }
    });
  };

  handleKeyPress = e => {
    const charCode = e.which ? e.which : e.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  resetInputValue = () => {
    this.InputRef.current.value = ""; //document.getElementById("multifactor_authentication")
  };

  updatePinLength = () => {
    this.setState({ pinLength: this.InputRef.current.value.length }); //document.getElementById("multifactor_authentication")

    if (this.props.error) {
      this.props.clearErrors();
    }

    if (this.state.showSuccessMessage) {
      this.setState({ showSuccessMessage: false });
    }
  };

  render() {
    const { pageContent, loading } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (loading) {
      return <RectangleLoader />;
    }

    return (
      <div>
        <Container>
          <div>
            <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children:
                        convertStringToElements(
                        replaceHashValues(pageContent.section_description, {
                          mobilenumber:
                          checkAMLob() === "agent"
                          ? window.reactGlobals.agentInfo.agentEmailId
                          : this.props.verifiedDevice
                      })
                    )
                 }

               }}
            
            
            />
          
            <div>
              <form onSubmit={this.handleSubmit}>
                  <InputContainer>
                    
                    <Input
                      name="pin"
                      type="password"
                      ref={this.InputRef}
                      label={pageContent.genericList[0].text}
                      // className={this.props.error || this.state.errorRequestingPin ? "icon" : ""}
                      required={true}
                      readOnly={false}
                      disabled={false}
                      error={this.props.error || this.state.errorRequestingPin || this.state.resendPWError ? true : false}
                      errorText={this.props.resendPWError ? convertStringToElements(this.props.resendPWError) : this.props.error && this.state.errorRequestingPin ? convertStringToElements(this.props.error) : this.props.error}
                      id="multifactor_authentication"
                      data-qm-encrypt="true"
                      maxLength="6"
                      autoComplete="off"
                      aria-describedby="multifactor_authentication_error"
                      onKeyPress={this.handleKeyPress}
                      onChange={this.updatePinLength}
                    />
                   
                  </InputContainer>
                <Body size="large">
                  {pageContent.genericList[0].list[1].text}
                  <TextLink 
                  type="inline" 
                  onClick={e => this.resendSecurePin()}>
                  {pageContent.genericList[0].list[1].jsonValue}
                </TextLink>
                </Body>
                <Button
                  type="submit"
                  disabled={this.state.pinLength < 6}
                  style={{ marginTop: "48px" }}
                  background={pageContent.buttons[0].type}
                >
                  {pageContent.buttons[0].text}
                </Button>
              </form>
            </div>
          </div>
        </Container>
        {this.state.showSuccessMessage ? (
          <Alert alertType="success" afterCloseRequest={() => this.setState({ showSuccessMessage: false })}>
            {convertStringToElements(pageContent.genericList[0].list[2].jsonValue)}
          </Alert>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({
  modalState,
  loadingAndErrorState,
  pageContent,
  verifiedSecurePinDevice,
  downloadAndDelete: { uniqueTxnId },
  pendingCase: { byPassEmail }
}) => ({
  showModal: modalState.showModal,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  resendPWError: loadingAndErrorState.resendPWError,
  pageContent: pageContent.multifactor_authentication,
  verifiedDevice: verifiedSecurePinDevice.verifiedDevice,
  uniqueTxnId,
  byPassEmail
});

export default connect(
  mapStateToProps,
  {
    validateSecurePin,
    setA11yContent,
    sendSecurePinToDevice,
    clearErrors,
    resendPassword,
    downloadResendPassword
  }
)(MultifactorAuthentication);

const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  max-width: 325px;
  margin-top: 5px;

  ${media.mobile`
    max-width: 100%;  
  `}
`;

const P = styled.p`
   margin-top: 24px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  display:flex;
`;


const Div = styled.div`
  p {
    margin: 10px 0;
    max-width: 600px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin-bottom: 32px;
  }

  ${media.mobile`
   p { 
    width: 100%;
  font-family: Verizon NHG eTX, Helvetica, Arial, sans-serif;;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
 }
  `};
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
     margin: 0;
    padding: 32px 16px ;
  `}
`;

const InputContainer = styled.div`
  flex: 50%;
  margin-top: 32px;
  margin-bottom: 5px;
  max-width: 385px;

  div {
    display: block;
  }

  .icon {
    padding-left: 25px;
    background: url(${Warning})no-repeat left;
    background-size: 20px;
    background-position: 99%;
    border: 1px solid  #C44904 !important;
    background-color:#FBE4D7;
    border-radius: 4px;
  }

  ${media.mobile`
    flex: 100%;
  `}
`;
// const Input = styled(ReactInput)`
//    width: 328px;
//   ${media.mobile`
//     width: 100%;
// `}
// `;
